import React, { Fragment } from "react";
import { Modal } from "react-bootstrap";

const TermsPopup = ({ showModalPopup, onPopupClose, schemelink = null }) => {
  const handleClose = () => {
    sessionStorage.setItem("stg_mo_redirectFrom", "Close the Alert on T&C");
    onPopupClose(false);
  };

  // Function to scroll to the target element after the modal opens
  const handleEntered = () => {
    const element = document.getElementById("prior-id");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Fragment>
      <Modal
        show={showModalPopup}
        onHide={handleClose}
        onEntered={handleEntered} /* Triggered once modal finishes opening */
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-modal-width"
        id="model_custome_css"
      >
        <Modal.Header closeButton>
          <Modal.Title className="blackClourV2 text-center"></Modal.Title>
        </Modal.Header>
        <Modal.Body className="tandcpopup">
          <div>
            <div className="contact_box_design">
              <div>
                <h4>Privacy Policy</h4>
                <hr style={{ borderTop: "1px solid #04a7d0" }} />
                <div
                  className="content text-dark"
                  style={{ padding: "20px 10px" }}
                >
                  <p>
                    HT Media Group recognizes the importance of maintaining the
                    privacy of every user who uses our apps/portals. We value
                    your privacy and appreciate your trust in us. We are
                    committed to be transparent about the data we collect about
                    you, how it is used and with whom it is shared.
                  </p>
                  <p>
                    The Privacy Policy (hereinafter referred to as “the Policy”)
                    provided hereinbelow is with respect to our use and protection
                    of any personal information you provide to us through website{" "}
                    <a href="/">https://HTreaders.com</a> (hereinafter referred to
                    as “Website”) which is owned by the HT Media Group and used by
                    all group entities under the HT Media Group which includes HT
                    Media Limited and its subsidiaries such as Hindustan Media
                    Ventures Limited and more and DCL and its subsidiaries
                    including HT Digital Streams Limited.
                  </p>
                  <p>
                    You may be required to provide personally identifiable
                    information at several different points on our website. By
                    accepting the policy at the time of registration, you
                    expressly approve and consent to our collection, storage,
                    use and disclosure of your personal information as described
                    in this Policy.
                  </p>
                  <h4>Information Collection</h4>
                  <p>
                    You will be able visit/surf website only if you are a
                    registered user of the website. The registration of website is
                    through self registered /or respective HT SPOC. You shall be
                    required to provide certain information for the registration
                    and/or access to such services/web pages. Such information
                    may include, without limitation, your name, email address,
                    contact address, mobile/telephone numbe (s), sex, age,
                    occupation, interests, financial information, content, IP
                    address, standard web log information and such other
                    information as may be required for your interaction with the
                    services
                  </p>
                  <h4>Use</h4>
                  <p>
                    If you choose to provide us with the above mentioned
                    information, you consent to the use, transfer and storage of
                    the information so provided by you on our servers. The
                    information provided by you shall not be sold/given/rented
                    to third parties (third parties for this purpose do not include
                    our group / holding / subsidiary companies and or our service
                    partners / associates) for marketing purposes and other
                    related activities without your prior consent.
                  </p>
                  <div>
                    <h4>
                      The information provided by you shall be used by us to:
                    </h4>
                    <ul>
                      <li>
                        Improve our website and enable us to provide you the
                        most user-friendly experience which is safe, smooth and
                        customized;
                      </li>
                      <li>
                        Improve and customize our services, content and other
                        commercial /non – commercial features on the website;
                      </li>
                      <li>
                        Send you information on our products, services, special
                        deals, promotions;
                      </li>
                      <li>
                        Send you marketing/promotional communications (If you do
                        not wish to receive such marketing/promotional
                        communications from us you may indicate your preferences
                        at the time of registration or by following the
                        instructions provided on the website or by providing
                        instructions to this effect);
                      </li>
                      <li>
                        Send newsletter(s) to you (Provided you subscribe to the
                        same);
                      </li>
                      <li>
                        Send you service-related announcements on rare occasions
                        when it is necessary to do so;
                      </li>
                      <li>
                        Provide you the opportunity to participate in contests
                        or surveys on our website (If you participate, we may
                        request certain additional personally identifiable
                        information from you. Moreover, participation in these
                        surveys or contests is shall be completely voluntary and
                        you therefore shall have a choice whether or not to
                        disclose such additional information);
                      </li>
                      <li>Provide customer support and the services you request;</li>
                      <li>Resolve disputes, if any and troubleshooting;</li>
                      <li>
                        Avoid/check illegal and/or potentially prohibited
                        activities and to enforce Agreements;
                      </li>
                      <li>
                        Provide service updates and promotional offers related
                        to our services/products.
                      </li>
                      <li>
                        Comply with any court judgment / decree / order /
                        directive / legal & government authority /applicable
                        law;
                      </li>
                      <li>
                        Investigate potential violations or applicable national &
                        international laws;
                      </li>
                      <li>
                        Investigate deliberate damage to the website/services or
                        its legitimate operation;
                      </li>
                      <li>
                        Detect, prevent, or otherwise address security and/or
                        technical issues;
                      </li>
                      <li>
                        Protect the rights, property or safety of HT Media Group
                        companies and/or their respective Directors, employees
                        and the general public at large; and
                      </li>
                      <li>Respond to Claims of third parties;</li>
                      <li>
                        The personal information provided by you shall also be
                        disclosed to:
                      </li>
                    </ul>
                  </div>
                  <p>
                    The members of our corporate family, affiliates, service
                    providers and third parties under a contract to provide joint
                    services, contents and marketing communications; and
                  </p>
                  <p>
                    Other third parties to whom you explicitly require us to send
                    the information;
                  </p>
                  <p>
                    If you choose to use our referral service to tell a friend
                    about our website, we will ask you for your friend’s name and
                    email address. We will automatically send your friend an
                    email inviting him or her to visit the website. However,
                    your friend may contact us to request that he does not
                    require such services/content/email or we remove the
                    information related to him from our database.
                  </p>
                  <p>
                    Based upon the personally identifiable information you
                    provide us, we will send you a welcoming email to verify your
                    username and password. We will also communicate with you in
                    response to your inquiries with respect to our
                    services/content, to provide the services you request, and to
                    manage your account. We will communicate with you by email
                    or telephone, in accordance with your wishes.
                  </p>
                  <p>
                    In order to provide certain services to you, we may on
                    occasion supplement the personal information you submitted to
                    us with information from third party sources (third parties
                    for this purpose may include our group / holding / subsidiary
                    companies and or our service partners / associates).
                  </p>
                  <p>
                    We reserve the right to disclose your personally identifiable
                    information as required by law and when we believe that
                    disclosure is necessary to protect our rights and/or to
                    comply with a judicial proceeding, court order, or legal
                    process served on our website.
                  </p>
                  <h4>Changing Your Personal Information</h4>
                  <p>
                    You can access and modify your personal information by
                    signing on to the website. We will not modify the
                    information provided by you. However, if you wish to update
                    your personal information as soon as such changes are
                    necessitated, it should be routed through a proper channel as
                    already communicated to you.
                  </p>
                  <p>
                    Where you make a public posting, you may not be able to
                    change or remove it nor shall you be able to close your
                    account. Upon your request, we will close your account and
                    remove your personal information from view as soon as
                    reasonably possible, based on your account activity and in
                    accordance with applicable law(s). However, we will retain
                    your personal information from closed accounts to comply with
                    law, Avoid/check illegal and/or potentially prohibited
                    activities and to enforce User Agreements; Comply with any
                    court judgment / decree / order / directive / legal &
                    government authority /applicable law; Investigate potential
                    violations or applicable national & international laws;
                    Investigate deliberate damage to the website/services or its
                    legitimate operation; Detect, prevent, or otherwise address
                    security and/or technical issues; Protect the rights,
                    property or safety of HT Media Group companies and/or their
                    respective Directors, employees and the general public at
                    large; Respond to Claims of third parties; and take such
                    other actions as may be permitted by law.
                  </p>
                  <h4>Account Protection</h4>
                  <p>
                    Your password is the key to your account. You shall be solely
                    responsible for all the activities happening under your
                    username and you shall be solely responsible for keeping your
                    password secure. Do not disclose your password to anyone. If
                    you share your password or your personal information with
                    others, you shall be solely responsible for all actions taken
                    under your username and you may lose substantial control over
                    your personal information and may be subject to legally
                    binding actions taken on your behalf. Therefore, if your
                    password has been compromised for any reason, you should
                    immediately change your password.
                  </p>
                  <h4>Business Transaction</h4>
                  <p>
                    In the event any of the HT Media Group company goes through a
                    business transition, such as a merger, acquisition by
                    another company, or sale of all or a portion of its assets,
                    your personally identifiable information will likely be
                    among the assets transferred. Where your information is
                    transferred you will be notified via email/prominent notice
                    on our website for 30 days of any such change in ownership or
                    control of your personal information.
                  </p>
                  <h4>Security</h4>
                  <p>
                    The security of your personal information is important to us.
                    When you enter your personal information we treat the data
                    as an asset that must be protected and use tools
                    (encryption, passwords, physical security, etc.) to protect
                    your personal information against unauthorized access and
                    disclosure. However, no method of transmission over the
                    Internet, or method of electronic storage, is 100% secure,
                    therefore, while we strive to use commercially acceptable
                    means to protect your personal information, we cannot
                    guarantee its absolute security nor can we guarantee that
                    third parties shall not unlawfully intercept or access
                    transmissions or private communications, and that other users
                    may abuse or misuse your personal information that you
                    provide. Therefore, although we work hard to protect your
                    information, we do not promise, and you should not expect,
                    that your personal information or private communications will
                    always remain private.
                  </p>
                  <h4>Links to Other Sites</h4>
                  <p>
                    The website may contains links to other sites that are not
                    owned or controlled by the HT Media Group companies. Please
                    be aware that we, HT Media Group and/or the website, are not
                    responsible for the privacy practices of such other sites.
                  </p>
                  <p>
                    We encourage you to be aware when you leave our site and to
                    read the privacy statements of each and every Web site that
                    collects personally identifiable information.
                  </p>
                  <p>
                    This privacy statement applies only to information collected
                    by the website or to our other related websites provided it
                    appears at the footer of the page therein. It does not apply
                    to third party advertisements which appear on our websites and
                    we suggest you read the privacy statements of such
                    advertisers.
                  </p>

                  <h4 id="prior-id">
                    Newspaper Subscription and Redemption Coupon
                  </h4>
                  <div>
                    <ul>
                      <li>
                        Subscription will be processed in the next four weeks,
                        subject to verification & payment realization. HT Media
                        Ltd. reserves the right to accept or reject any or all
                        booking received at its sole discretion without
                        assigning any reason whatsoever.
                      </li>
                      <li>
                        In case of loss/theft/damage/misplacement of cheque(s),
                        HT Media Ltd. shall not be responsible or liable.
                        Subscription will be processed only after realization of
                        the subscription payment.
                      </li>
                      <li>
                        Newspaper delivery under the subscription offer will be
                        made through the regular market Newspaper Vendor. We
                        advise you to confirm the terms of delivery with your
                        Vendor before enrolment. HT Media Ltd. will not be
                        responsible for any Newspaper vendor-related disputes.
                        Any area-specific service charges levied by your local
                        vendor have to be paid directly by the subscriber to the
                        vendor.
                      </li>
                      <li>
                        In case of Physical coupon, the subscription coupon
                        booklet/coupons will be delivered at the address
                        mentioned on the subscription form, within 15 days from
                        the date of payment realization.
                      </li>
                      <li>
                        In case of M-Coupons, the coupons will be shared via SMS
                        / Email / WhatsApp. You can redeem or check status of
                        your M-Coupon redemption by logging in to
                        htreaders.com with your registered mobile number.
                      </li>
                      <li>
                        The monthly redemption coupons should be handed over to
                        the newspaper vendor only after receiving the newspaper
                        copies for that respective month, and not before.
                      </li>
                    </ul>
                  </div>

                  <h4>Changes in this Privacy Statement</h4>
                  <p>
                    If we decide to change our privacy policy, we will post those
                    changes to this privacy statement and such other places we
                    deem appropriate so that you are updated about the manner we
                    collect information, what information we collect, how we use
                    it and under what circumstances, if any, we disclose it. We
                    reserve the right to modify this privacy statement at any
                    time, so please review it frequently at Contact Us
                  </p>

                  <p>
                    If you have any questions or suggestions regarding our
                    privacy policy, please contact us as per details given in the
                    footer.
                  </p>
                  <p>Copyright © HT Media Ltd. All rights reserved.</p>
                  <div>
                    <ul>
                      <li>
                        <a
                          href="https://www.htmedia.in/about-us"
                          target="_blank"
                          rel="noreferrer"
                        >
                          About Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.htmedia.in/contact-us"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Contact Us
                        </a>
                      </li>
                      <li>
                        <a href="/refund-policy">Refund Policy</a>
                      </li>
                      <li>
                        <a href="/privacy-policy">Privacy Policy</a>
                      </li>
                      {schemelink && (
                        <li>
                          <a
                            href={schemelink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Selected Scheme Terms & Conditions
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default TermsPopup;